import React, { useCallback } from 'react'
import styled from 'styled-components'
import { Formik, Form } from 'formik'
import { Link, useHistory } from 'react-router-dom'
import { useMutation } from 'graphql-hooks'
import { useDispatch } from 'react-redux'
import swal from 'services/swal'

import Field from '../../atoms/Field'
import { Button } from '../../atoms/Button'
import userSlice from '../../../redux/user'

const LOGIN_MUTATION = `mutation Login($input: UsersPermissionsLoginInput!) {
  login(input: $input) {
    jwt
    user {
      id
      username
      email
      blocked
      confirmed
      phoneNumber
    }
  }
}`

const initialValues = {
  email: '',
  password: '',
}

function validate(values) {
  const errors = {}

  if (!values.email) {
    errors.email = 'Inserisci una mail'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Inserisci una mail valida'
  }

  if (!values.password) {
    errors.password = 'Inserisci una password'
  }

  return errors
}

export default function LoginForm() {
  const history = useHistory()
  const [doLogin] = useMutation(LOGIN_MUTATION)
  const dispatch = useDispatch()

  const onSubmit = useCallback(
    async (values) => {
      const res = await doLogin({
        variables: {
          input: { identifier: values.email, password: values.password },
        },
      })

      if (res.error) {
        if (
          res.error?.graphQLErrors?.some(
            (e) => e?.extensions?.exception?.code === 400
          )
        ) {
          swal.warn({
            text:
              'Non abbiamo riconosciuto il tuo account. Sei sicuro di esserti registrato?',
          })
        } else {
          swal.error({
            text: 'Si è verificato un errore imprevisto.',
          })
        }
        console.log(res.error)
      } else {
        console.log(res)
        dispatch(userSlice.actions.setUserInfo(res.data.login))
        history.push('/home')
      }
    },
    [history, doLogin, dispatch]
  )

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnMount
      validate={validate}
    >
      {({ isSubmitting, isValid }) => (
        <Form>
          <Field
            name="email"
            type="email"
            placeholder="La tua email"
            label="Indirizzo email"
          />

          <Field
            name="password"
            type="password"
            label="Password"
            placeholder="La tua password"
          />

          <Link to="/recupera-password">password dimenticata?</Link>

          <Footer>
            <Button
              as="input"
              type="submit"
              value="login"
              disabled={isSubmitting || !isValid}
            />
          </Footer>
        </Form>
      )}
    </Formik>
  )
}

const Footer = styled.footer`
  margin-top: 32px;

  input[type='submit'] {
    width: 100%;
  }
`
